import { getDreamControllerFindOneQueryKey } from '@/api/dreams/dreams'
import { DreamDto } from '@/api/model'
import { client } from '@/features/query/client'
import { InfiniteData } from '@tanstack/react-query'
import { Listeners } from 'src/api/sse'

export const dreamFrozen: Listeners['dream.frozen'][number] = (e) => {
  const { payload } = e.data

  const { dreamId, amount } = payload || {}

  client.setQueryData(
    getDreamControllerFindOneQueryKey(dreamId),
    (data: DreamDto) => {
      if (!data) return data

      return { ...data, status: 'frozen', currentAmount: amount } as DreamDto
    },
  )

  client.setQueriesData(
    { queryKey: ['dreams'] },
    (data: InfiniteData<{ data: DreamDto[] }>) => {
      if (!data) return data
      return {
        ...data,
        pages: data.pages.map((el) => {
          return {
            ...el,
            data: el.data.filter((el) => el.id !== dreamId),
          }
        }),
      } as InfiniteData<{ data: DreamDto[] }>
    },
  )
}
